import React from 'react';
import PropTypes from 'prop-types';
import { RndPhone } from 'components/RndPhone';
import { RndEmail } from 'components/RndEmail';

const LoginFailed = ({ errorMessage = 'Login failed.' }) => (
   <span>
      {errorMessage} Please contact RND Customer Support at <RndPhone /> or{' '}
      <RndEmail /> for assistance.
   </span>
);

LoginFailed.propTypes = {
   errorMessage: PropTypes.string,
};

export { LoginFailed };
